import React, { type ComponentType, type FC, type ReactNode, useMemo, useState } from 'react';
import upperFirst from 'lodash/upperFirst';
import { useActivatedPromocodesFreePeriod } from '@cp/entities/promocode';
import { Box, type BoxProps } from '@cp/ds/src/components/box';
import { ClickAwayListener } from '@mui/material';
import { Tooltip } from '@cp/ds/src/components/tooltip';
import { HOC } from 'src/shared/componentBuilder';
import { StartSubscriptionLink } from './startSubscriptionLink';

export type SubscriptionTooltipInjectedProps = {
  tooltipText: ReactNode;
};

const TooltipContent: FC<BoxProps & { children: ReactNode }> = ({ children, ...boxProps }) => {
  const promocodePeriod = useActivatedPromocodesFreePeriod();
  const freePeriod = useMemo(() => (promocodePeriod ? ` ${upperFirst(promocodePeriod)} - бесплатно` : ''), [promocodePeriod]);

  return (
    <Box sx={{ px: 1.75, py: 1 }} {...boxProps}>
      {children}&nbsp;
      <StartSubscriptionLink color="pink" underline>
        оформить подписку.
      </StartSubscriptionLink>
      {freePeriod}
    </Box>
  );
};

export const withSubscriptionTooltip: HOC<SubscriptionTooltipInjectedProps> = <TBaseProps extends object>(
  Component: ComponentType<TBaseProps>,
): ComponentType<TBaseProps & SubscriptionTooltipInjectedProps> => {
  return (props) => {
    const [open, setOpen] = useState(false);
    const { tooltipText, ...rest } = props;

    return (
      <Tooltip
        arrow
        colorSchema="dark"
        disableHoverListener
        open={open}
        title={
          <ClickAwayListener onClickAway={() => setOpen(false)}>
            <div>
              <TooltipContent onClick={() => setOpen(false)}>{tooltipText}</TooltipContent>
            </div>
          </ClickAwayListener>
        }
      >
        <Component {...(rest as TBaseProps)} onPaymentRequired={() => setOpen(true)} />
      </Tooltip>
    );
  };
};
